import * as React from 'react';
import { RemoveFavorite } from '../../components/RemoveFavorite';
import { useSelector } from 'react-redux';
import { selectResults } from '../../selectors/results';
import { EDealType, EEntityType } from '../../types/filters';
import { ModalConfirmRemoveFromFolderContainer } from '../MassActions/remove/ModalConfirmRemoveFromFolderContainer';
import { ModalConfirmRemoveContainer } from '../MassActions/remove/ModalConfirmRemoveContainer';
import { selectSelectedFolder } from '../../selectors/folders';
import { trackClickRemoveFromFolder } from './tracking';

interface IRemoveFavoriteContainerProps {
  dealType: EDealType;
  entityId: number;
  favoriteEntityType: EEntityType;
}

export function RemoveFavoriteContainer({ dealType, entityId, favoriteEntityType }: IRemoveFavoriteContainerProps) {
  const [isConfirmModalVisible, setConfirmModalVisible] = React.useState(false);
  const { removeFavorite, favoriteEntities } = useSelector(selectResults);
  const selectedFolder = useSelector(selectSelectedFolder);

  const handleClose = () => {
    setConfirmModalVisible(false);
  };

  const handleClick = () => {
    trackClickRemoveFromFolder(entityId, favoriteEntities);
    setConfirmModalVisible(true);
  };

  let modal;
  if (selectedFolder) {
    modal = <ModalConfirmRemoveFromFolderContainer entityId={entityId} onClose={handleClose} />;
  } else {
    modal = <ModalConfirmRemoveContainer entityId={entityId} onClose={handleClose} />;
  }

  return (
    <React.Fragment>
      {isConfirmModalVisible && modal}
      <RemoveFavorite
        removeFavoriteState={removeFavorite}
        entityId={entityId}
        favoriteEntityType={favoriteEntityType}
        dealType={dealType}
        onClick={handleClick}
      />
    </React.Fragment>
  );
}
